import React, { useState } from 'react'
import { Stepper } from 'selfServicePortal/components/Stepper/stepper'
import { useTranslation } from 'react-i18next'
import { useStepper } from 'selfServicePortal/components/Stepper/use-stepper'
import { AddressForm } from './AddressForm'
import './index.scss'
import { AddressSecurityCode } from './AddressSecurityCode'
import { AddressOtp } from './AddressOtp'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { ICustomer } from 'selfServicePortal/interfaces/i-api-customer'
import { Success } from '../Success'

interface AddressChangeProps {
	onGoBack: () => void
}

export function AddressChange({ onGoBack }: AddressChangeProps) {
	const { t } = useTranslation()
	const { stepAmount, activeStep, nextStep, prevStep, isFirstStep } =
		useStepper({
			stepAmount: 4,
			initialStep: 1,
		})
	const [customer, setCustomer] = useState<ICustomer>()
	const [sessionId, setSessionId] = useState<string>()

	return (
		<div className="address-change">
			<Stepper stepAmount={stepAmount} activeStep={activeStep} />
			<div className="back-button">
				<FontAwesomeIcon icon={faChevronLeft} />
				<button onClick={isFirstStep ? onGoBack : prevStep}>
					{t('Back')}
				</button>
			</div>

			{activeStep === 1 && (
				<AddressForm
					onSuccess={(customer) => {
						setCustomer(customer)
						nextStep()
					}}
				/>
			)}
			{activeStep === 2 &&
				(customer !== undefined ? (
					<AddressSecurityCode
						customer={customer}
						onSuccess={(sessionId) => {
							setSessionId(sessionId)
							nextStep()
						}}
					/>
				) : null)}
			{activeStep === 3 && (
				<AddressOtp sessionId={sessionId} onSuccess={nextStep} />
			)}
			{activeStep === 4 && <Success onSuccess={onGoBack} />}
		</div>
	)
}
